import DrawerBlockComponent from "../../../../uiKit/Drawer/components/DrawerBlockComponent"
import { CheckboxFormItem, formItemLayoutBalanced, renderInputFormItem } from "../../_components/SettingFormItems"
import { SettingRow } from "./SettingRow"
import { ImageUpload } from "../../../../uiKit/ImageUpload/ImageUpload"
import { CropType, ImageUploadType } from "../../../../uiKit/ImageUpload/types"
import { Button, Form } from "antd"
import MibMainMenuIconSelect from "./MibMainMenuIconSelect"
import * as React from "react"
import { CSSProperties } from "react"
import { SettingFormItem } from "../../types"
import { WrappedFormUtils } from "antd/lib/form/Form"
import { MibLayoutSelectRow } from "./MibLayoutSelectRow"
import { DEFAULT_MIB_COLOR, MibColorRow } from "./MibColorRow"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { InputOnOffCheckbox } from "./InputOnOffCheckbox"
import { OrderingModePickerSection } from "./OrderingModePickerSection"
import { appendHostnameToImageUrl } from "../utils"
import { AntdIconWrap } from "../../../../uiKit/Icons/AntdIconWrap"
import { Router } from "../../../../../server/router"
import { renderLink, renderQrCode } from "./MibSettingsHeader"
import { Terminal } from "../../../../../graphql/types"
import { Color } from "../../../../../constants"
import { getFirstCroppedVariantUrl } from "../../../../uiKit/ImageUpload/utils"
import { PrimaryColor } from "../../../../../constants/colors"

type Props = {
    mainMenuIcon: string
    defaultLayoutTemplate: Maybe<number>
    isDiscountEnabled: boolean
    isFirstTimeDiscountEnabled: boolean
    isEcoFriendlyEnabled: boolean
    discountValue: Maybe<number>
    firstTimeDiscountValue: Maybe<number>
    isBannerMessageEnabled: boolean
    isAbilityToPayWithEgcEnabled: boolean
    logoUrl: Maybe<string>
    desktopImageUrl: Maybe<string>
    iconUrl: Maybe<string>
    selectedTerminalData: Maybe<Terminal>
    settings: SettingFormItem
    form: WrappedFormUtils
    onStateValueChanged: (stateKey: string, value: Maybe<any>) => void
    onChangeCallback: () => void
    onOrderingModeChange: (type: Maybe<string>) => void
}

export const MibSeparatedGeneralSettings = (props: Props) => {
    return (
        <DrawerBlockComponent
            title="Make It Butter Settings"
            style={{
                padding: 0,
            }}>
            <SettingRow
                borderPosition="bottom"
                label={
                    <div>
                        <AntdIconWrap style={styles.checkIcon} type="check" />
                        <span>Your site is online at &nbsp;</span>
                        <span>{props.selectedTerminalData ? renderLink(props.selectedTerminalData) : null}</span>
                    </div>
                }>
                {props.selectedTerminalData ? (
                    <div>{renderQrCode(props.selectedTerminalData, "download-button")}</div>
                ) : null}
            </SettingRow>
            <SettingRow borderPosition="bottom" label="Locations Picker Page Appearance">
                <Button onClick={() => Router.push("/make-it-butter-settings/homepageAppearance")}>
                    Edit Appearance
                </Button>
            </SettingRow>
            <MibLayoutSelectRow
                defaultLayoutTemplate={props.defaultLayoutTemplate}
                onChangeCallback={props.onChangeCallback}
                onStateValueChanged={props.onStateValueChanged}
            />
            {CheckboxFormItem(
                props.settings,
                "MIB_HIDE_SERVICE_FROM_LOCATION_PICKER_PAGE",
                "Do not display this service in the location picker",
                props.form,
                null,
                props.onChangeCallback,
                "receipt-setting-form-item",
                "Hide this service from being selected under ‘Choose location’"
            )}
            <MibColorRow settings={props.settings} form={props.form} onChangeCallback={props.onChangeCallback} />
            <SettingRow
                label="Custom Logo"
                helpText="This image will represent your business throughout the ordering website">
                <ImageUpload
                    type={ImageUploadType.Single}
                    className={classes.imageUpload}
                    offerImageCrop={true}
                    imageOptions={{
                        maxWidth: 1800,
                        maxHeight: 300,
                    }}
                    cropModalTitle="Crop logo image"
                    value={
                        props.logoUrl
                            ? [
                                  {
                                      originalImage: {
                                          id: "mib-logo",
                                          url: appendHostnameToImageUrl(props.logoUrl) as string,
                                      },
                                  },
                              ]
                            : []
                    }
                    onChange={result => {
                        props.onChangeCallback()
                        props.onStateValueChanged("logoUrl", getFirstCroppedVariantUrl(result))
                    }}
                />
            </SettingRow>
            <SettingRow
                label="Custom Icon"
                helpText="This image will be used when customers save the website to Favorites or Home Screen.">
                <ImageUpload
                    className={classes.imageUpload}
                    type={ImageUploadType.Single}
                    cropModalTitle="Crop icon image"
                    imageOptions={{
                        maxWidth: 512,
                        maxHeight: 512,
                        minWidth: 512,
                        minHeight: 512,
                    }}
                    offerImageCrop={true}
                    cropOptions={[
                        {
                            defaultWidth: 512,
                            defaultHeight: 512,
                            cropType: CropType.Ratio_1_1,
                        },
                    ]}
                    value={
                        props.iconUrl
                            ? [
                                  {
                                      originalImage: {
                                          id: "mib-icon",
                                          url: appendHostnameToImageUrl(props.iconUrl) as string,
                                      },
                                  },
                              ]
                            : []
                    }
                    onChange={result => {
                        props.onChangeCallback()
                        props.onStateValueChanged("iconUrl", getFirstCroppedVariantUrl(result))
                    }}
                />
            </SettingRow>
            <SettingRow
                label="Desktop web header hero image"
                helpText="This image will be visible on desktop version, in the header. Recommended size: 1920 x 300 pixels">
                <ImageUpload
                    className={classes.imageUpload}
                    type={ImageUploadType.Single}
                    cropModalTitle="Crop desktop hero image"
                    imageOptions={{
                        forceJpeg: true,
                        maxWidth: 1920,
                        maxHeight: 300,
                        minWidth: 1920,
                        minHeight: 300,
                    }}
                    offerImageCrop={true}
                    cropOptions={[
                        {
                            defaultWidth: 1920,
                            defaultHeight: 300,
                            locked: true,
                            cropType: CropType.Free,
                        },
                    ]}
                    value={
                        props.desktopImageUrl
                            ? [
                                  {
                                      originalImage: {
                                          id: "mib-bg-image",
                                          url: appendHostnameToImageUrl(props.desktopImageUrl) as string,
                                      },
                                  },
                              ]
                            : []
                    }
                    onChange={result => {
                        props.onChangeCallback()
                        props.onStateValueChanged("desktopImageUrl", getFirstCroppedVariantUrl(result))
                    }}
                />
            </SettingRow>
            {CheckboxFormItem(
                props.settings,
                "MIB_DESKTOP_DISPLAY_BUSINESS_INFO_BOX",
                "Display business name and details on hero image",
                props.form,
                null,
                props.onChangeCallback,
                "receipt-setting-form-item"
            )}
            <div>
                <Form.Item
                    style={{
                        marginBottom: "0rem",
                    }}
                    className="receipt-setting-form-item"
                    {...formItemLayoutBalanced}
                    label="Main Menu Type">
                    <MibMainMenuIconSelect
                        iconColor={
                            props.form.getFieldValue("MIB_PRIMARY_COLOR") ||
                            props.settings.MIB_PRIMARY_COLOR.value ||
                            DEFAULT_MIB_COLOR
                        }
                        value={props.mainMenuIcon}
                        onChangeCallback={value => {
                            props.onStateValueChanged("mainMenuIcon", value)
                            props.onChangeCallback()
                        }}
                    />
                </Form.Item>
            </div>
            <InputOnOffCheckbox
                settings={props.settings}
                key="MIB_BANNER_MESSAGE"
                stateKey="isBannerMessageEnabled"
                stateFieldValue={props.isBannerMessageEnabled}
                label="Banner Messaging"
                helperText="Promotional messaging for your customers. Will be displayed on top of ordering page. Limited to 90 characters."
                onChangeCallback={props.onChangeCallback}
                onStateValueChanged={props.onStateValueChanged}
                className="receipt-setting-form-item"
            />
            {props.isBannerMessageEnabled && (
                <div
                    style={{
                        marginBottom: "0.5rem",
                        marginLeft: "2rem",
                        marginTop: "-0.5rem",
                    }}>
                    {renderInputFormItem(
                        props.settings,
                        "MIB_BANNER_MESSAGE",
                        " ",
                        "Enter message",
                        props.form,
                        {
                            borderTop: "none",
                        },
                        props.onChangeCallback,
                        "receipt-setting-form-item promo-code-word",
                        null,
                        false,
                        null,
                        {
                            width: "16rem",
                            textAlign: "left",
                            position: "relative",
                            top: "4px",
                        },
                        {},
                        {
                            maxLength: 90,
                        }
                    )}
                </div>
            )}
            <InputOnOffCheckbox
                settings={props.settings}
                key="MIB_ECO_FRIENDLY_OPTION_ENABLED"
                stateKey="isEcoFriendlyEnabled"
                stateFieldValue={props.isEcoFriendlyEnabled}
                label="Enable eco-friendly option during customer checkout"
                helperText='Inquires customers to "Go Green! Do not include plastic utensils"'
                onChangeCallback={props.onChangeCallback}
                onStateValueChanged={props.onStateValueChanged}
                className="receipt-setting-form-item"
            />
            {props.isEcoFriendlyEnabled && (
                <div className={classes.padLeft}>
                    {CheckboxFormItem(
                        props.settings,
                        "MIB_ECO_FRIENDLY_OPTION_DEFAULT_CHECKED",
                        "Prompt eco-friendly option as default behavior",
                        props.form,
                        null,
                        props.onChangeCallback,
                        "receipt-setting-form-item",
                        "Customers will need to deselect eco-friendly as an option if they require utensils"
                    )}
                </div>
            )}
            {CheckboxFormItem(
                props.settings,
                "FUTURE_ORDERING_DATE_ONLY",
                "Enable Date Only for Future Orders",
                props.form,
                null,
                props.onChangeCallback,
                "receipt-setting-form-item",
                "Future orders will be scheduled for a specific date without a specified time"
            )}
            <DrawerBlockComponent title="Select Ordering Scheme" containerClassName="my-4">
                <OrderingModePickerSection
                    settings={props.settings}
                    form={props.form}
                    onOrderingModeChange={props.onOrderingModeChange}
                />
            </DrawerBlockComponent>
        </DrawerBlockComponent>
    )
}

const styles: Record<string, CSSProperties> = {
    checkIcon: {
        color: PrimaryColor,
        fontSize: "1.1rem",
        marginRight: "0.5rem",
    },
    link: {
        textDecoration: "underline",
        color: Color.PrimaryColor,
    },
}

const classes = {
    imageUpload: "w-[250px] max-h-[70px]",
    padLeft: "ml-8",
}
